"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var NavigationBlockPrompt = function NavigationBlockPrompt(_ref) {
  var when = _ref.when,
    children = _ref.children,
    checkIgnoreLocation = _ref.checkIgnoreLocation;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    location = _useState2[0],
    setLocation = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    opened = _useState4[0],
    setOpened = _useState4[1];
  var unblock = _react.default.useRef();
  var history = (0, _reactRouterDom.useHistory)();
  var onConfirm = (0, _react.useCallback)(function () {
    if (unblock.current) {
      unblock.current();
    }
    history.push(location);
  }, [history, location]);
  var onCancel = function onCancel() {
    setOpened(false);
    setLocation(undefined);
  };
  (0, _react.useEffect)(function () {
    unblock.current = history.block(function (nextLocation) {
      if (checkIgnoreLocation != null && checkIgnoreLocation(nextLocation)) {
        return true;
      }
      setLocation(nextLocation);
      setOpened(true);
      return !when;
    });
    return function () {
      if (unblock.current) {
        unblock.current();
      }
    };
  }, [when, checkIgnoreLocation, history]);
  return children({
    isOpened: opened,
    onCancel,
    onConfirm
  });
};
var _default = exports.default = NavigationBlockPrompt;